/*!
	Zoom 1.7.14
	license: MIT
	http://www.jacklmoore.com/zoom
*/
(function ($) {
	var defaults = {
		url: false,
		callback: false,
		target: false,
		trigger: false,
		duration: 120,
		on: 'mouseover', // other options: grab, click, toggle
		touch: true, // enables a touch fallback
		onZoomIn: false,
		onZoomOut: false,
		magnify: 1
	};

	// Core Zoom Logic, independent of event listeners.
	$.zoom = function(target, trigger, source, img, magnify) {
		var targetHeight,
			targetWidth,
			sourceHeight,
			sourceWidth,
			xRatio,
			yRatio,
			offset,
			$target = $(target),
			$trigger = $(trigger),
			position = $target.css('position'),
			$source = $(source);

		// The parent element needs positioning so that the zoomed element can be correctly positioned within.
		$target.css('position', /(absolute|fixed)/.test(position) ? position : 'relative');
		$target.css('overflow', 'hidden');

		img.style.width = img.style.height = '';

		$(img)
			.addClass('zoomImg') // needsclick
			.css({
				position: 'absolute',
				top: -1 * (img.height * magnify) / 2,
				left: -1 * (img.width * magnify) / 2,
				opacity: 0,
				display: 'none',
				width: img.width * magnify,
				height: img.height * magnify,
				border: 'none',
				maxWidth: 'none',
				maxHeight: 'none'
			})
			.appendTo(target);
			// console.log('$.zoom', $(img).css('top'), $(img).css('left'));

		return {
			init: function() {
				targetWidth = $target.outerWidth();
				targetHeight = $target.outerHeight();

				if (source === $target[0]) {
					sourceWidth = targetWidth;
					sourceHeight = targetHeight;
				} else {
					sourceWidth = $source.outerWidth();
					sourceHeight = $source.outerHeight();
				}

				// console.log('init w', parseInt(img.style.width), img.width, targetWidth, sourceWidth);
				// console.log(img);
				xRatio = ((parseInt(img.style.width) - targetWidth) / sourceWidth);
				yRatio = ((parseInt(img.style.height) - targetHeight) / sourceHeight);

				offset = $source.offset();
			},
			move: function (e) {
				var left = (e.pageX - offset.left),
					top = (e.pageY - offset.top);

				top = Math.max(Math.min(top, sourceHeight), 0);
				left = Math.max(Math.min(left, sourceWidth), 0);
				// console.log('move y:', top, yRatio, 'x:', left, xRatio);
				img.style.left = (left * -xRatio) + 'px';
				img.style.top = (top * -yRatio) + 'px';
			}
		};
	};

	$.fn.zoom = function (options) {
		return this.each(function () {
			var
			settings = $.extend({}, defaults, options || {}),
			//target will display the zoomed image
			target = settings.target || this,
			//designate an element beside the source to trigger an activation click on
			trigger = settings.trigger || this,
			//source will provide zoom location info (thumbnail)
			source = this,
			$source = $(source),
			$target = $(target),
			$trigger = $(trigger),
			img = document.createElement('img'),
			$img = $(img),
			mousemove = 'mousemove.zoom',
			clicked = false,
			touched = false,
			zooming = false,
			zoomed = false,
			moved = false,
			$urlElement;

			// If a url wasn't specified, look for an image element.
			if (!settings.url) {
				$urlElement = $source.find('img');
				if ($urlElement[0]) {
					settings.url = $urlElement.data('src') || $urlElement.attr('src');
				}
				if (!settings.url) {
					return;
				}
			}

			(function(){
				var position = $target.css('position');
				var overflow = $target.css('overflow');

				$source.one('zoom.destroy', function(){
					$source.off(".zoom");
					$target.css('position', position);
					$target.css('overflow', overflow);
					$img.remove();
				});
				
			}());

			img.onload = function () {
				var zoom = $.zoom(target, trigger, source, img, settings.magnify);

				function start(e) {
					zoom.init();
					// zoom.move(e);
					// $('#ProductDetails .name').html('start()<br/>' + $('#ProductDetails .name').html());
					// console.trace('start()', e);

					// Skip the fade-in for IE8 and lower since it chokes on fading-in
					// and changing position based on mousemovement at the same time.
					$img.stop()
					.show()
					.fadeTo($.support.opacity ? settings.duration : 0, 1, $.isFunction(settings.onZoomIn) ? settings.onZoomIn.call(img) : false);
				}

				function stop(e) {
					// $('#ProductDetails .name').html('<hr/>stop()<br/>' + $('#ProductDetails .name').html());
					// console.trace('stop()', e, event);
					$img.stop()
					// .fadeTo(settings.duration, 0, $.isFunction(settings.onZoomOut) ? settings.onZoomOut.call(img) : false);
					.fadeTo(settings.duration, 0, function() {
						$img.hide();
						$.isFunction(settings.onZoomOut) ? settings.onZoomOut.call(img) : false;
					});
				}

				// Mouse events
				if (settings.on === 'grab') {
					$source
						.on('mousedown.zoom',
							function (e) {
								if (e.which === 1) {
									$(document).one('mouseup.zoom',
										function () {
											stop();

											$(document).off(mousemove, zoom.move);
										}
									);

									start(e);

									$(document).on(mousemove, zoom.move);

									e.preventDefault();
								}
							}
						);
				} else if (settings.on === 'click') {
					$trigger.on('click.zoom',
						function (e) {
							if (clicked) {
								// bubble the event up to the document to trigger the unbind.
								return;
							} else {
								clicked = true;
								start(e);
								$(document).on(mousemove, zoom.move);
								$(document).one('click.zoom',
									function (e) {
										// $('#ProductDetails .name').html('doc.click.zoom<br/>' + $('#ProductDetails .name').html());
										stop(e);
										clicked = false;
										$(document).off(mousemove, zoom.move);
									}
								);
								return false;
							}
						}
					);
				} else if (settings.on === 'toggle') {
					$source.on('click.zoom',
						function (e) {
							// $('#ProductDetails .name').html('doc.toggle.zoom<br/>' + $('#ProductDetails .name').html());
							if (clicked) {
								stop();
							} else {
								start(e);
							}
							clicked = !clicked;
						}
					);
				} else if (settings.on === 'mouseover') {
					zoom.init(); // Preemptively call init because IE7 will fire the mousemove handler before the hover handler.

					$source
						.on('mouseenter.zoom', start)
						.on('mouseleave.zoom', stop)
						.on(mousemove, zoom.move);
				}

				// Touch fallback
				if (settings.touch) {
					// console.log('setup touch', $trigger, $target);
					$trigger
						.on('touchstart.zoom', function (e) {
							e.preventDefault();
							e.stopImmediatePropagation();
							moved = false;
							if (zoomed) { //touched
								// console.log('touchstart1', touched, this.className, e);
								// $('#ProductDetails .name').html('touchstart1.zoom ' + zooming + ' ' + moved + '<br/>' + $('#ProductDetails .name').html());
								// touched = false;
								// zoomed = false;
								// stop();
							} else {
								// console.log('touchstart2', touched, this.className, e);
								// $('#ProductDetails .name').html('touchstart2.zoom ' + zooming + ' ' + moved + '<br/>' + $('#ProductDetails .name').html());
								// touched = true;
								// zoomed = true;
								zooming = true;
								// start( e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] );
								// $('#ProductDetails .name').html('touchstart2b ' + zooming + ' ' + moved + '<br/>' + $('#ProductDetails .name').html());
							}
						})
						.on('touchend.zoom', function (e) {
							e.preventDefault();
							e.stopImmediatePropagation();
							// console.log('touchend1', touched, this.className, e);
							// $('#ProductDetails .name').html('touchend1 ' + zooming + ' ' + moved + '<br/>' + $('#ProductDetails .name').html());
							if (zooming && !moved) {
								zoomed = true;
								start( e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] );
							}
							else if (!zooming && !moved) {
								// touched = false;
								zoomed = false;
								stop();
							}
							zooming = false;
							// $('#ProductDetails .name').html('<hr/>' + $('#ProductDetails .name').html());
						});
					$target
						.on('touchstart.zoom', function (e) {
							e.preventDefault();
							moved = false;
							// console.log('touchstart3', zooming, this.className, e);
							// $('#ProductDetails .name').html('touchstart3 ' + zooming + ' ' + moved + '<br/>' + $('#ProductDetails .name').html());
							if (zoomed) {
								// console.log('touchstart3a', zooming, this.className, e);
								// touched = false;
								// stop();
							} else {
								// console.log('touchstart3b', zooming, this.className, e);
								// touched = true;
								// zooming = true;
								// start( e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] );
							}
						})
						/*.on('touchend.zoom', function (e) {
							e.preventDefault();
							if (touched) {
								touched = false;
								stop();
							}
							});*/
						.on('touchend.zoom', function (e) {
							e.preventDefault();
							// e.stopImmediatePropagation();
							// console.log('touchend2.zoom', zooming, moved, this.className, e);
							// $('#ProductDetails .name').html('touchend2 ' + zooming + ' ' + moved + '<br/>' + $('#ProductDetails .name').html());
							if (zooming && !moved) {
								zoomed = true;
								start( e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] );
							}
							else if (!zooming && !moved) {
								// touched = false;
								// console.log('touchend2b', zooming, moved, this.className, e);
								// $('#ProductDetails .name').html('touchend2b ' + zooming + ' ' + moved + '<br/>' + $('#ProductDetails .name').html());
								zoomed = false;
								stop();
							}
							zooming = false;
							// $('#ProductDetails .name').html('<hr/>' + $('#ProductDetails .name').html());
						});
					$target.find('.zoomImg')
						.on('touchmove.zoom', function (e) {
							e.preventDefault();
							moved = true;
							// console.log('touchmove.zoom', this.className, e);
							// $('#ProductDetails .name').html('touchmove ' + touched + ' ' + moved + '<br/>' + $('#ProductDetails .name').html());
							zoom.move( e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] );
							e.stopImmediatePropagation();
						});
				}
				
				if ($.isFunction(settings.callback)) {
					settings.callback.call(img);
				}
			};

			img.src = settings.url;
		});
	};

	$.fn.zoom.defaults = defaults;
}(window.jQuery));
